import React from "react"

import { gql } from "urql"

import { useQuery } from "hooks/urql"

import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import Form from "./Form"

type EditAcrClassProps = {
  acrClassId: string
}

const EditAcrClass: React.FC<EditAcrClassProps> = ({ acrClassId }) => {
  const [result] = useQuery({
    query: acrClassQuery,
    variables: { acrClassId },
  })

  return (
    <UrqlLoadingIndicator result={result}>
      {({ data }) => <Form acrClass={data.acrClass} />}
    </UrqlLoadingIndicator>
  )
}

const acrClassQuery = gql`
  query AdminAcrClassFormEdit($acrClassId: ID!) {
    acrClass(id: $acrClassId) {
      id
      name
      school {
        id
        name
      }
      teacher {
        id
        fullName
      }
      subject {
        id
        name
      }
      grade {
        id
        name
      }
    }
  }
`

export default EditAcrClass
